module.exports = __webpack_public_path__ + "static/media/MyTasksUpIcon.9021b034.svg";